import React from 'react';

import { useLocale } from '@adsk/alloy-react-locale';
import NEmptyState from '@adsk/nirvana-empty-state';

type EmptyStateProps = {
  title: React.ReactNode;
};

const EmptyState = ({ title }: EmptyStateProps) => {
  const { T } = useLocale(({ locale }) => require(`../locale/${locale}.json`));
  return <NEmptyState gray illustration="sheets" title={title || T.translate('emptyResult')} />;
};

export default EmptyState;
